module.exports = __webpack_public_path__ + "static/media/assignTruck.437804cc.svg";